import React, { useState } from "react";
import { Link } from "react-router-dom";
import beginners_track from "../images/entrylevel1.png";
import "../styles/BeginnersTrack.css";
import { motion } from "framer-motion";
import useRegistrationStatus from "../hooks/useRegistrationStatus";
import sogo from "../images/image1.png";
import toba from "../images/image2.png";
import eri from "../images/image3.png";
import back from "../images/back.png"

const BeginnersTrack = () => {
  const { registrationData } = useRegistrationStatus();
  

  const data = [
    {
      question: "Module 1: Intro to Programming (Weeks 1-8)",
      answer:
        "Week 1: General Intro (What is programming? How programming is transforming AI and ML applications). Weeks 2-3: Git Intro (Version control, collaborative coding, and AI-assisted development using tools like GitHub Copilot).",
      buttons: [{ text: "Resources", to: "/page1" }],
    },
    {
      question: "Module 2: Python Fundamentals (Weeks 4-8)",
      answer:
        "Week 4: Data Types, Variables, Keywords. Use of AI tools like PyCharm's smart assistance to learn code patterns. Weeks 5-6: Control Structures (Decision and Repetition, intro to AI decision-making in apps). Weeks 7-8: Functions and Advanced Concepts - Named Functions, Recursion, Generators, Decorators, Lambda Functions. AI-supported function analysis (tools that provide code completion and optimization tips).",
      buttons: [{ text: "Resources", to: "/page2" }],
    },
    {
      question: "Module 3: Intro to OOP (Weeks 9-11)",
      answer:
        "Core principles: Classes, Inheritance, Encapsulation, Abstraction, Polymorphism. Example projects: Simulate chatbots using basic OOP concepts. AI use case: Integrate small AI models to showcase OOP with ML model classes.",
      buttons: [{ text: "Resources", to: "/page3" }],
    },
    {
      question: "Module 4: Modules, Packages, and Unit Testing (Weeks 12-13)",
      answer:
        "Modules and Packages: Learn to work with Python modules and AI/ML-specific libraries like scikit-learn and Hugging Face Transformers. Unit Testing: Validate small AI tasks using unittest. Mini-project: Build a module that interacts with a language model API (e.g., OpenAI's GPT).",
      buttons: [{ text: "Resources", to: "/page4" }],
    },
  ];

  const mentors = [
    {
      name: "Sogo Ogundowole",
      role: "Senior Data Engineer",
      image: sogo,
    },
    {
      name: "Oluwatoba Adesugba",
      role: "ML Engineer and Technical Writer",
      image: toba,
    },
    {
      name: "Erioluwa Asiru",
      role: "Backend Developer",
      image: eri,
    },
  ];

  return (
    <div className="beginner_wrapper" id="beginnersPage">
      <div className="beginner-container">
        <div className="beginner-content">
          <div className="back_home">
            <Link className="scrolllink" to="/#sectionToScroll">
              <img src={back} alt="goback" className="goback" />
              {/* <span>Back</span> */}
            </Link>
          </div>

          <h1>
            Beginners <span className="orange">tracks</span>
          </h1>
          <motion.p
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
          >
            Embark on your data adventure with our Beginner's Track. Designed
            for those taking their first strides into the world of data, this
            track provides a structured roadmap to transform novices into savvy
            analysts.
          </motion.p>

          {!registrationData?.is_open && (
            <div className="button">
              <Link to="/FormInput" className="reserve-btns">
                <button>Join the Waitlist</button>
              </Link>
            </div>
          )}
        </div>

        <div className="faq_mentors_text">
          <h1>
            Track <span className="oranges">Modules</span>
          </h1>
        </div>

        <div className="modules-grid-container">
          <div className="modules-grid">
            {data.map((item, i) => (
              <div className="module-card" key={i}>
                <div className="module-header">
                  <h3>{item.question}</h3>
                </div>
                <div className="module-content">
                  <p>{item.answer}</p>
                </div>
                <div className="module-buttons">
                  {item.buttons.map((button, index) => (
                    <Link key={index} to={button.to} className="module-btn">
                      {button.text}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mentors">
          <div className="beginners_mentors_text">
            <h1>
              Meet your <span className="oranges">Instructors</span>
            </h1>
            <p>These are your instructors for the next couple of weeks</p>
          </div>

          <div className="beginners_mentors_container">
            {mentors.map((mentor, i) => (
              <div className="beginners_mentor_wraps" key={i}>
                <div className="mentor_image_wrap">
                  <img
                    src={mentor.image}
                    alt={mentor.name}
                    className="beginners_mentor_images"
                  />
                </div>
                <div className="mentor_para">
                  <h3>{mentor.name}</h3>
                  <p>{mentor.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeginnersTrack;
